import PeopleRouteStore from './store/Store';
import './mutators/setCurrentPeopleRouteMutator';

export { default as PeopleRouteType } from './store/schema/PeopleRouteType';
export default PeopleRouteStore;
